/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MachineApprovalModel
 */
export interface MachineApprovalModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineApprovalModel
     */
    machineIds?: Array<number> | null;
}

export function MachineApprovalModelFromJSON(json: any): MachineApprovalModel {
    return MachineApprovalModelFromJSONTyped(json, false);
}

export function MachineApprovalModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineApprovalModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'machineIds': !exists(json, 'machineIds') ? undefined : json['machineIds'],
    };
}

export function MachineApprovalModelToJSON(value?: MachineApprovalModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'machineIds': value.machineIds,
    };
}

